'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  if (!clientConfig || __TEST__) {
    loadConfig();
  }

  return clientConfig;
};

/* eslint-disable no-underscore-dangle */

var clientConfig = void 0;

var loadConfig = function loadConfig() {
  clientConfig = null;

  if (__SERVER__) {
    if (__TEST__ && global.__TEST_CLIENT_CONFIG__) {
      clientConfig = global.__TEST_CLIENT_CONFIG__;
    } else {
      clientConfig = require('./config').clientConfig; // eslint-disable-line global-require
    }
  } else if (__CLIENT__) {
    var configNode = document.getElementById('client-config');
    if (configNode) {
      clientConfig = JSON.parse(configNode.textContent);
    } else if (__TEST__) {
      clientConfig = window.__TEST_CLIENT_CONFIG__ || {};
    }
  }

  if (!clientConfig) {
    throw new Error('Could not find a valid client configuration.');
  }
};